import { render, staticRenderFns } from "./ScenicComposite.vue?vue&type=template&id=dbda1294&scoped=true"
import script from "./ScenicComposite.vue?vue&type=script&lang=js"
export * from "./ScenicComposite.vue?vue&type=script&lang=js"
import style0 from "./ScenicComposite.vue?vue&type=style&index=0&id=dbda1294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbda1294",
  null
  
)

export default component.exports